import { render } from "./tenant-create.vue?vue&type=template&id=e99e87ce"
import script from "./tenant-create.vue?vue&type=script&lang=js"
export * from "./tenant-create.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__